module.exports = __webpack_public_path__ + "media/images/proof_links/colored/hulu-e8e7492e665ca37fe767a008316bb8f1.svg";